import React from 'react';
import './TechSlider.css';

const TechSlider = () => {
  return (
    <div className="techslider">
      <div className="slider__logos">
        <div className="logo__items">
          <div className="logo__slider">Python</div>
          <div className="logo__slider">Ruby</div>
          <div className="logo__slider">React</div>
          <div className="logo__slider">Flask</div>
          <div className="logo__slider">Rails</div>
          <div className="logo__slider">NodeJS</div>
          <div className="logo__slider">FastAPI</div>
          <div className="logo__slider">Next.js</div>
          <div className="logo__slider">OpenAI</div>
        </div>
        <div className="logo__items">
          <div className="logo__slider">Python</div>
          <div className="logo__slider">Ruby</div>
          <div className="logo__slider">React</div>
          <div className="logo__slider">Flask</div>
          <div className="logo__slider">Rails</div>
          <div className="logo__slider">NodeJS</div>
          <div className="logo__slider">FastAPI</div>
          <div className="logo__slider">Next.js</div>
          <div className="logo__slider">OpenAI</div>
        </div>
      </div>

      <div className="slider__logos responsiveSlider">
        <div className="logo__items">
          <div className="logo__slider">Flask</div>
          <div className="logo__slider">Rails</div>
          <div className="logo__slider">Python</div>
          <div className="logo__slider">React</div>
          <div className="logo__slider">Ruby</div>
          <div className="logo__slider">NodeJS</div>
          <div className="logo__slider">FastAPI</div>
          <div className="logo__slider">Next.js</div>
          <div className="logo__slider">OpenAI</div>
        </div>
        <div className="logo__items">
          <div className="logo__slider">Flask</div>
          <div className="logo__slider">Rails</div>
          <div className="logo__slider">Python</div>
          <div className="logo__slider">React</div>
          <div className="logo__slider">Ruby</div>
          <div className="logo__slider">NodeJS</div>
          <div className="logo__slider">FastAPI</div>
          <div className="logo__slider">Next.js</div>
          <div className="logo__slider">OpenAI</div>
        </div>
      </div>
    </div>
  );
};

export default TechSlider;
